import { get, patch, put } from '../../utils/http';

export const fetchSpecificOsTimeSheet = ({ accountId, timesheetId }) =>
  get(`/accounts/${accountId}/timesheets/os/${timesheetId}`);

export const editOSTimesheet = ({ accountId, timesheetId, timesheet, shouldWaitForBreaktimes }) =>
  patch(`/accounts/${accountId}/timesheets/os/${timesheetId}`, {
    ...timesheet,
    options: { shouldWaitForBreaktimes }
  });

export const approveOSAll = ({ accountId, ids, signature }) =>
  put(`/accounts/${accountId}/timesheets/os/approve`, { ids, signature });

export const autoFillOSTimeSheet = ({ accountId, ids, override, shouldWaitForBreaktimes }) =>
  put(`/accounts/${accountId}/timesheets/os/autofill`, { ids, override, options: { shouldWaitForBreaktimes } });

export const autoFillOSTimeSheetBreaks = ({ accountId, breaktimes }) =>
  put(`/accounts/${accountId}/timesheets/os/autoFillBreaks`, {
    breaktimes
  });
